import { Assignment } from '@deltek/specification-client/core/Models/assignment'
/**
* This is a sorter function to be used with
* array.sort(). It sorts values alphabetically
* in ascending order
*/
export const sortByProperty = (_: Partial<Assignment>[]) => {
  return function (a: Partial<Assignment>, b: Partial<Assignment>) {
    const text1 =
      a?.user?.profileInfo?.firstName?.toLowerCase() +
      ' ' +
      a?.user?.profileInfo?.lastName?.toLowerCase()
    const text2 =
      b?.user?.profileInfo?.firstName?.toLowerCase() +
      ' ' +
      b?.user?.profileInfo?.lastName?.toLowerCase()
    if (text1 && text2) {
      if (text1 > text2) return 1
      else if (text1 < text2) return -1
    }
    return 0
  }
}

export const getProjectTeamName = (projectTeamName: string) => {
  switch (projectTeamName.toLowerCase()) {
    case 'building product manufacturer':
      return 'Building Product Manufacturer'
    case 'facilities management':
      return 'Facilities Management'
    default:
      return projectTeamName
  }
}